// extracted by mini-css-extract-plugin
export default {"HomeFaqs":"K1Tk7wu3","HomeFaqsTitle":"XVu6Rfo8","HomeFaqsAccordion":"DDmo5UFT"};